import {formatOutputCurrency, numberToUSD, resultsURLFromState} from './modules/utilities';
import React from 'react';
import ReactDOM from 'react-dom';
import Control from './components/Control.jsx';
import CalculatorOutput from './components/Output.jsx';
import SharingButtons from './components/SharingWidget.jsx';

/**
 * Window load
 */
window.onload = () => {
  ReactDOM.render(<Calculator />, document.getElementById('react-root'));
};

class Calculator extends React.Component {
  constructor(props) {
    super(props);

    let url = window.location.href;
    let params = new URLSearchParams(window.location.search);

    this.state = {
      formSubmitted: url.includes('results') || false,
      propertyValue: +params.get('propertyValue') || undefined,
      teacherPay: +params.get('teacherPay') || 5,
      artTeachers: +params.get('artTeachers') || 0,
      instructionalSupport: +params.get('instructionalSupport') || 0,
      apCredits: params.get('apCredits') === 'true',
      schoolMaintenance: params.get('schoolMaintenance') === 'true',
      propertyValueError: {status: false, message: ''},
      countyCurrent: +params.get('countyCurrent') || 0,
      countyProposed: +params.get('countyProposed') || 0,
      myAmount: +params.get('myAmount') || 0,
      myBudget: +params.get('myBudget') || 0,
      monthlyAmount: +params.get('monthlyAmount') || 0
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.onRangeChange = this.onRangeChange.bind(this);
    this.onSwitchChange = this.onSwitchChange.bind(this);
    this.changePropertyValue = this.changePropertyValue.bind(this);
  }

  handleSubmit(e) {
    e.preventDefault();

    if (!this.state.propertyValue) {
      let error = this.state.propertyValueError;
      error.status = true;
      error.message = 'Property value is required'
      this.setState({propertyValueError: error});
    } else if (+this.state.propertyValue > 10000000) {
      error.status = true;
      error.message = 'Amount cannot be more than $10,000,000';
      this.setState({propertyValueError: error});
    } else {
      this.calculate(this.redirect);
    }
  }

  calculate(callback) {
    const assessedValue = +this.state.propertyValue * .25 / 100;
    const countyRateCurrent = 2.7652;
    const countyRateProposed = countyRateCurrent + .34;

    let myRate = countyRateProposed;
    myRate += (+this.state.teacherPay - 5) * .025;
    myRate += +this.state.artTeachers * .000084;
    myRate += +this.state.instructionalSupport * .0005365;
    myRate += (this.state.schoolMaintenance) ? .209 : 0;
    myRate += (this.state.apCredits) ? .03345 : 0;

    const countyCurrent = Math.round(assessedValue * countyRateCurrent);
    const countyProposed = Math.round(assessedValue * countyRateProposed);
    const myAmount = Math.round(assessedValue * myRate);
    const monthlyAmount = Math.round((myAmount - countyCurrent) / 12);
    const formSubmitted = true;

    const myBudget = Math.round((myRate - countyRateCurrent) * 1000000 / .01);
    this.setState({countyCurrent, countyProposed, formSubmitted, myAmount, monthlyAmount, myBudget}, callback);
  }

  redirect() {
    const url = resultsURLFromState(this.state);
    window.history.pushState({}, "Title", url);
    this.setState({formSubmitted: true});
  }

  changePropertyValue(e) {
    let propertyValue = +e.target.value.replace(/\$/g, '').replace(/,/g, '');
    let error = this.state.propertyValueError;

    if (isNaN(+propertyValue)) {
      error.status = true;
      error.message = 'Must be a numeric value or currency amount'
    } else if (+propertyValue > 10000000) {
      error.status = true;
      error.message = 'Amount cannot be more than $10,000,000';
    } else {
      error.status = false;
      error.message = '';
    }

    this.setState({propertyValue, propertyValueError: error });
  }

  // Generic event handlers for range and switch inputs
  onRangeChange(e) {
    this.setState({[e.target.name]: +e.target.value});
  }

  onSwitchChange(name, value) {
    this.setState({[name]: value})
  }

  render() {
    const formSubmitted = this.state.formSubmitted;
    const TextLabel = <span>Home Value<span aria-hidden='true'> (required)</span></span>;
    const propertyValue = this.state.propertyValue;

    const TextInputGroup = (
      <div className='input-group'>
        <Control
          error={this.state.propertyValueError}
          id='property-value'
          label={TextLabel}
          name='propertyValue'
          onChange={this.changePropertyValue}
          type='text'
          value={numberToUSD(propertyValue)}
        />
      </div>
    );

    const RangeInputGroup = (
      <fieldset className='input-group'>
        <Control
          id='teacher-pay'
          label='Increase Teacher Pay'
          min={5}
          max={10}
          name='teacherPay'
          onChange={this.onRangeChange}
          step={1}
          symbol='%'
          type='range'
          value={this.state.teacherPay}
        />
        <Control
          id='art-teachers'
          label='Art Teachers'
          min={0}
          max={100}
          name='artTeachers'
          onChange={this.onRangeChange}
          step={20}
          symbol='%'
          type='range'
          value={this.state.artTeachers}
        />
        <Control
          id='instructional-support'
          label='Fund Instructional Support'
          min={0}
          max={100}
          name='instructionalSupport'
          onChange={this.onRangeChange}
          step={20}
          symbol='%'
          type='range'
          value={this.state.instructionalSupport}
        />
      </fieldset>
    );

    const SwitchInputGroup = (
      <fieldset className='input-group'>
        <Control
          id='ap-credits'
          label='Fund Post-Secondary Credits'
          name='apCredits'
          onClick={this.onSwitchChange}
          type='switch'
          value={this.state.apCredits}
        />
        <Control
          id='school-maintenance'
          label='Fund School Maintenance'
          name='schoolMaintenance'
          onClick={this.onSwitchChange}
          type='switch'
          value={this.state.schoolMaintenance}
        />
      </fieldset>
    );

    const {countyCurrent, countyProposed, myAmount, myBudget, monthlyAmount} = this.state;
    const resultsURL = resultsURLFromState(this.state);

    const CalculatorResults = (
      <div className='calculator__results'>
        <CalculatorOutput
          countyCurrent={formatOutputCurrency(countyCurrent)}
          countyProposed={formatOutputCurrency(countyProposed)}
          myIncreases={formatOutputCurrency(myAmount - countyProposed)}
          myAmount={formatOutputCurrency(myAmount)}
          myBudget={formatOutputCurrency(myBudget)}
          monthlyAmount={formatOutputCurrency(monthlyAmount)}
        />
        <SharingButtons message='Here is my budget for Hamilton County school' url={encodeURIComponent(resultsURL)} />
      </div>
    );

    return (
      <div
        className={(formSubmitted) ? 'calculator calculator--submitted' : 'calculator'}
        id='calculator-results'
      >
        <h2 className='calculator__title'>My School Budget</h2>
        <div className='calculator__container'>
          <form className='calculator__form' onSubmit={this.handleSubmit}>
            {TextInputGroup}
            {RangeInputGroup}
            {SwitchInputGroup}
            <button type='submit'>Calculate</button>
          </form>

          {formSubmitted ? CalculatorResults : undefined}
        </div>
      </div>
    );
  }
}
